import React, { useEffect, useState } from "react";
import img2 from "../../assets/images/smalladhaar.jpeg";
import img3 from "../../assets/images/signImg.png";
import { getBase64 } from "../../Functions/Utils";
import { ManageApis } from "../../AppServices/ManageApi";
import AlertBox from "../../Components/AlertBox/AlertBox";
import Loader from "../../Components/LoaderComponent/Loader";
import Capture from "../../Components/CaptureImage/Capture";
import { camHandler } from "../../FaceMesh/camHandler";
import nodata from "../../assets/images/no-data.png";
function FaceMatching() {
    const [isLoading, setisLoading] = useState(false);
    const [openCam, setOpenCam] = useState(false);

    const [uploadFileData, setUploadFileData] = useState({
        primaryFile: "",
        secondryFile: "",
    });
    const [responseData, setResponseData] = useState({});
    const AlertinitialValue = {
        show: false,
        message: "",
        isfalse: false,
        isSuccess: false,
    };
    const [showAlert, setShowAlert] = useState(AlertinitialValue);

    let headers = {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Key: "aasdapld7!!458856akspksiklsjj-sklsp@#sjkdkldi",
        },
    };
    const handleCamClose = () => {
        setOpenCam(false);
        // setUploadFileData((pre)=>({...pre,primaryFile:""}))
        camHandler.clearTracks();
    };

    useEffect(() => {
        //console.log(openCam);
    }, [openCam]);

    const handleFileUpload = async (event, type) => {
        setisLoading(true);
        const file = event.target.files[0];
        const imgtype = file?.type?.split("/").pop();
        if (!file) return setisLoading(false); console.error("No file selected.");

        try {
            const base64Data = await getBase64(file);

            setUploadFileData((prevData) => ({
                ...prevData,
                secondryFile: base64Data,
            }));
            setisLoading(false);
        } catch (error) {
            setisLoading(false);
            console.error("Error converting file to base64:", error);
        }
    };

    const handleMatchScore = async () => {
        try {
            if (Object.values(uploadFileData).every((itm) => itm)) {

                setisLoading(true);
                const rqstData = {
                    face1: uploadFileData?.primaryFile,
                    face2: uploadFileData?.secondryFile,
                };

                let response = await ManageApis("post", global.faceMactching, rqstData);

                if (response.message === "Success") {
                    //console.log(response.response_data);
                    // "";
                    setResponseData(response?.response_data);

                    setisLoading(false);
                } else {
                    //console.log(response);
                    // "";
                    setShowAlert((pre) => ({
                        ...pre,
                        show: true,
                        message: typeof (response.response_data) === "string" ? response.response_data : "Something went wrong...!",
                        isSuccess: false,
                        isfalse: true,
                    }));
                    //console.log(response);
                    setisLoading(false);
                }
            }
        } catch (err) {
            setisLoading(false);
            console.error(err);
        }
    };

    const onload = async () => {
        setisLoading(true);
        camHandler
            .getCam()
            .then((res) => {
                document.getElementById("camera").srcObject = camHandler.videoStrem;
                document.getElementById("camera").style.transform = "scaleX(-1)";
                // //console.log(camHandler._camList);
                // //console.log(
                //   " numberof cam------------------------=",
                //   camHandler.videoStrem
                // );
                // "";
                document.getElementById("camera").addEventListener(
                    "canplay",

                    async () => {
                        document.getElementById("camera").play();
                        setisLoading(false);
                    },
                    { once: true }
                );
                setisLoading(false);
            })
            .catch((err) => {
                //console.log("cam error", err.toString().split(":")[1], err);

                setisLoading(false);

                handleCamClose();

                // //console.log(err.message)

                if (err.name == "NotFoundError" || err.name == "DevicesNotFoundError") {
                    // count < 2 && setAlertMessage(MESSAGES.MEDIA_NO_CAM_DETECTED);

                    setShowAlert((pre) => ({
                        ...pre,
                        show: true,
                        message: "Camera Permission Denied",
                        isSuccess: false,
                        isfalse: true,
                    }));
                } else if (
                    err.name == "NotAllowedError" ||
                    err.name == "PermissionDeniedError"
                ) {
                    setShowAlert((pre) => ({
                        ...pre,
                        show: true,
                        message: "Camera Permission Denied",
                        isSuccess: false,
                        isfalse: true,
                    }));
                    // //console.log("Sorry...Could not get the video !!!")
                    //   count < 2 && setAlertMessage(MESSAGES.MEDIA_PERMISSION_DENIED);
                }
            });
        // document.getElementById("camera").srcObject = camHandler.videoStrem;
        // document.getElementById("camera").style.transform = "scaleX(-1)";
        // document.getElementById("camera").addEventListener("canplay", async () => {}, { once: true });
        // document.getElementById("camera").play();
    };
    const handleCapture = (param) => {
        // "";
        setResponseData({})
        if (param == "primaryFile") {
            setUploadFileData((pre) => ({ ...pre, primaryFile: "" }));
            setOpenCam(true);
            onload();
        }
    };

    const formateResponse = () => {
        if (responseData && responseData?.msg == "success") {
            return (
                <>
                    <h4 className="fw_600 font_40 text_master2 text-center mb-0">
                        {responseData?.verified}
                    </h4>
                    <h4 className="fw_600 font_40 text_master2 text-center mb-0">
                        {responseData?.match_percentage}%
                    </h4>
                </>
            );
        } else if (responseData?.msg !== "success") {
            return (
                <div className="d-flex flex-column align-items-center mt-0 ">
                    {/* <img
            src={nodata}
            className="no_data_thumbnail object_fit_contain d-none"
          /> */}
                    <h4 className="font_16 mb-0 mt-3 text-center text_gray7">
                        <p className="mb-2">{`Unable To Process Data `}</p>
                        <p className="mb-0">{responseData?.msg}</p>
                    </h4>
                </div>
            );
        }
    };

    return (
        <>
            {isLoading && <Loader />}
            <AlertBox
                show={showAlert.show}
                message={showAlert.message}
                enableFailIcon={showAlert.isfalse}
                enableSuccessIcon={showAlert.isSuccess}
                handlecancel={() => setShowAlert(AlertinitialValue)}
            />
            <div className="main__section bg-white shadow_sm4 overflow-hidden mt-4 w-100  br_15">
                <div className=" ">
                    <div className="bx1 scrollbar1  ms-0 ms-md-3 row align-items-center rounded  p-2">
                        {/* {["primaryFile", "secondryFile"].map((itm, index) => (
                                <div key={index} className="bd_dotted_0 bd_dotted_md bd_master2 border-bottom-0 border-start-0 border-top-0 col-12 col-md-5">
                                    <div
                                        className={`bg_gray2    d-flex w-100 rounded ${uploadFileData[itm] ? "d-none" : ""
                                            } upload_box`}
                                    >
                                        <div className=" m-auto">
                                            <h2 className="font_13 font_600 text-center mb-3">
                                                {itm == "primaryFile" ? "Please Capture your Image" : "Please upload a document"}
                                            </h2>


                                            {
                                                <div
                                                    className="d-flex align-items-center justify-content-center"
                                                    onClick={() => handleCapture(itm)}
                                                >
                                                    <label className="UploadLabel bg_master_gradient px-5 py-2 font_12 font_600 text-white border outline rounded-pillbg_master_gradient px-5 py-2 font_12 font_600 text-white border outline rounded-pill cursor-pointer">
                                                        {itm == "primaryFile" ? "Capture" : "Upload"}
                                                        {itm !== "primaryFile" && (
                                                            <input
                                                                accept={".jpeg,.jpg,.png"}
                                                                type="file"
                                                                className="d-none"
                                                                onChange={(e) => handleFileUpload(e, itm)}
                                                            />
                                                        )}
                                                    </label>
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div className={` ${uploadFileData[itm] ? "" : "d-none"}  `}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h2 className="py-2 py-sm-3 mb-0 text-uppercase font_13 fw-bold ws_nowrp text_master2 text-center">
                                                    UPLOADED DATA
                                                </h2>
                                                <div className=" bg_gray2 rounded p-2">
                                                    <img
                                                        src={uploadFileData[itm]}
                                                        loading="lazy"
                                                        className="w-100 rounded object_fit_contain UploadSignExtractImg"
                                                    />
                                                </div>
                                            </div>

                                            <h3 className="font_13 mb-0 pt-3 text-center  ">

                                                {itm == "primaryFile" ? "Capture Image" : "upload a file?"}
                                                <label
                                                    className="text_master2 ms-1"
                                                    onClick={() => handleCapture(itm)}
                                                >
                                                    Click here
                                                    {itm !== "primaryFile" && (
                                                        <input
                                                            type="file"
                                                            className="d-none"
                                                            accept={"png,jpeg,jpg"}
                                                            onChange={(e) => handleFileUpload(e, itm)}
                                                        />
                                                    )}
                                                </label>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            ))} */}
                        {/* capture side */}
                        <div className="bd_dotted_0 h-100 bd_dotted_md bd_master2 border-bottom-0 border-start-0 border-top-0 col-12 d-flex col-md-6">
                            <h2 className="font_13 d-none font_600 text-center mb-3">
                                {"primaryFile" == "primaryFile" ? "Please Capture your Image" : "Please upload a document"}
                            </h2>
                            <div
                                className={` m-auto   d-flex w-100 rounded ${uploadFileData["primaryFile"] ? "d-none" : ""
                                    } `}
                            >
                                <div className=" m-auto">
                                    <div className='mb-2 text-center'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="142" height="161" viewBox="0 0 142 161" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.11401 51.5707C8.11401 49.4107 9.86504 47.6597 12.025 47.6597H54.109C56.269 47.6597 58.02 49.4107 58.02 51.5707V67.1465H137.06C139.512 67.1465 141.5 69.1341 141.5 71.586V156.395C141.5 158.847 139.512 160.835 137.06 160.835H12.5536C10.1017 160.835 8.11407 158.847 8.11407 156.395V81.9422L8.11401 81.9213V51.5707Z" fill="#004C92" />
                                            <rect x="23.2548" y="0.165405" width="113.103" height="128.43" fill="#F6F6F6" />
                                            <rect x="31.9755" y="9.15018" width="95.6616" height="5.18445" fill="#E4E4E4" />
                                            <rect x="31.9755" y="26.5912" width="95.6616" height="4.22814" fill="#E4E4E4" />
                                            <rect x="31.9755" y="35.576" width="95.6616" height="4.22814" fill="#E4E4E4" />
                                            <rect x="31.9755" y="44.5608" width="95.6616" height="4.22814" fill="#E4E4E4" />
                                            <rect x="31.9755" y="53.5456" width="95.6616" height="4.22814" fill="#E4E4E4" />
                                            <rect x="31.9755" y="62.5304" width="95.6616" height="4.22814" fill="#E4E4E4" />
                                            <rect x="31.9755" y="71.5152" width="95.6616" height="4.22814" fill="#F6F6F6" />
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 60.6278C0 58.4678 1.75103 56.7167 3.91103 56.7167H46.0338C48.1938 56.7167 49.9449 58.4678 49.9449 60.6278L49.9449 68.3442V71.6474C49.9449 72.9887 50.6252 75.3802 53.1056 76.0077H129.54C131.991 76.0077 133.979 77.9953 133.979 80.4472V156.395C133.979 158.847 131.991 160.835 129.54 160.835H4.43955C1.98766 160.835 0 158.847 0 156.395V90.5947V80.4472V60.6278Z" fill="#1A82E2" />
                                            <g filter="url(#filter0_d_64_936)">
                                                <path d="M69.1156 132.559H65.6563V111.803L56.1429 121.316L53.6868 118.86L67.386 105.161L81.0851 118.86L78.629 121.316L69.1156 111.803V132.559Z" fill="white" />
                                            </g>
                                            <defs>
                                                <filter id="filter0_d_64_936" x="51.5727" y="105.161" width="31.6265" height="31.6265" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                    <feOffset dy="2.11407" />
                                                    <feGaussianBlur stdDeviation="1.05703" />
                                                    <feComposite in2="hardAlpha" operator="out" />
                                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_64_936" />
                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_64_936" result="shape" />
                                                </filter>
                                            </defs>
                                        </svg>
                                    </div>
                                    <h2 className='font_15 text-center fw-light pt-3 mb-2'>This model is ready to Capture your image</h2>
                                    <h3 className='text_master2 text-center font_15 pt-2 mb-0'>Click to Capture your image files</h3>
                                    <div className="bg_lightdark upload_thumb d-none object_fit_contain w-100   p-1 br_15">
                                        <img src={uploadFileData.primaryFile} className=" object_fit_contain w-100 h-100  p-3" />
                                    </div>

                                    {
                                        <div
                                            className="d-flex mt-4 align-items-center justify-content-center"
                                            onClick={() => handleCapture("primaryFile")}
                                        >
                                            <label className="bg_master2 px-4 br_5  py-2">
                                                {"primaryFile" == "primaryFile" ? "Capture" : "Upload"}
                                                {"primaryFile" !== "primaryFile" && (
                                                    <input
                                                        accept={".jpeg,.jpg,.png"}
                                                        type="file"
                                                        className="d-none"
                                                        onChange={(e) => handleFileUpload(e, "primaryFile")}
                                                    />
                                                )}
                                            </label>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className={` ${uploadFileData["primaryFile"] ? "" : "d-none"}  `}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h2 className="py-2 py-sm-3 mb-0 font_13 fw-bold ws_nowrp  text-center">
                                            Uploaded data
                                        </h2>
                                        <div className="  rounded p-2">
                                            <img
                                                src={uploadFileData["primaryFile"]}
                                                loading="lazy"
                                                className="w-100 rounded object_fit_contain UploadSignExtractImg"
                                            />
                                        </div>
                                    </div>

                                    <h3 className="font_13 mb-0 pt-2 text-center  ">

                                        {"primaryFile" == "primaryFile" ? "Capture a Image?" : "upload a file?"}
                                        <label
                                            className="text_master2 ms-1"
                                            onClick={() => handleCapture("primaryFile")}
                                        >
                                            Click here
                                            {"primaryFile" !== "primaryFile" && (
                                                <input
                                                    type="file"
                                                    className="d-none"
                                                    accept={"png,jpeg,jpg"}
                                                    onChange={(e) => handleFileUpload(e, "primaryFile")}
                                                />
                                            )}
                                        </label>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        {/*  */}
                        {/* Upload side */}
                        <div className="d-flex h-100  border-bottom-0 border-start-0 border-top-0 col-12 col-md-6">
                            <div
                                className={`m-auto d-flex w-100 rounded ${uploadFileData["secondryFile"] ? "d-none" : ""
                                    } upload_box`}
                            >
                                <div className=" m-auto">
                                    <div className='mb-2 text-center'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="142" height="161" viewBox="0 0 142 161" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.11401 51.5707C8.11401 49.4107 9.86504 47.6597 12.025 47.6597H54.109C56.269 47.6597 58.02 49.4107 58.02 51.5707V67.1465H137.06C139.512 67.1465 141.5 69.1341 141.5 71.586V156.395C141.5 158.847 139.512 160.835 137.06 160.835H12.5536C10.1017 160.835 8.11407 158.847 8.11407 156.395V81.9422L8.11401 81.9213V51.5707Z" fill="#004C92" />
                                            <rect x="23.2548" y="0.165405" width="113.103" height="128.43" fill="#F6F6F6" />
                                            <rect x="31.9755" y="9.15018" width="95.6616" height="5.18445" fill="#E4E4E4" />
                                            <rect x="31.9755" y="26.5912" width="95.6616" height="4.22814" fill="#E4E4E4" />
                                            <rect x="31.9755" y="35.576" width="95.6616" height="4.22814" fill="#E4E4E4" />
                                            <rect x="31.9755" y="44.5608" width="95.6616" height="4.22814" fill="#E4E4E4" />
                                            <rect x="31.9755" y="53.5456" width="95.6616" height="4.22814" fill="#E4E4E4" />
                                            <rect x="31.9755" y="62.5304" width="95.6616" height="4.22814" fill="#E4E4E4" />
                                            <rect x="31.9755" y="71.5152" width="95.6616" height="4.22814" fill="#F6F6F6" />
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 60.6278C0 58.4678 1.75103 56.7167 3.91103 56.7167H46.0338C48.1938 56.7167 49.9449 58.4678 49.9449 60.6278L49.9449 68.3442V71.6474C49.9449 72.9887 50.6252 75.3802 53.1056 76.0077H129.54C131.991 76.0077 133.979 77.9953 133.979 80.4472V156.395C133.979 158.847 131.991 160.835 129.54 160.835H4.43955C1.98766 160.835 0 158.847 0 156.395V90.5947V80.4472V60.6278Z" fill="#1A82E2" />
                                            <g filter="url(#filter0_d_64_936)">
                                                <path d="M69.1156 132.559H65.6563V111.803L56.1429 121.316L53.6868 118.86L67.386 105.161L81.0851 118.86L78.629 121.316L69.1156 111.803V132.559Z" fill="white" />
                                            </g>
                                            <defs>
                                                <filter id="filter0_d_64_936" x="51.5727" y="105.161" width="31.6265" height="31.6265" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                    <feOffset dy="2.11407" />
                                                    <feGaussianBlur stdDeviation="1.05703" />
                                                    <feComposite in2="hardAlpha" operator="out" />
                                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_64_936" />
                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_64_936" result="shape" />
                                                </filter>
                                            </defs>
                                        </svg>
                                    </div>
                                    <h2 className='font_15 text-center fw-light pt-3 mb-2'>This model is ready to Upload your image</h2>
                                    <h3 className='text_master2 text-center font_15 pt-2 mb-0'>Click to Upload your image files</h3>
                                    <h2 className="font_13 d-none font_600 text-center mb-3">
                                        {"secondryFile" == "primaryFile" ? "Please Capture your Image" : "Please upload a document"}
                                    </h2>


                                    {
                                        <div
                                            className="d-flex mt-4 align-items-center justify-content-center"
                                            onClick={() => handleCapture("secondryFile")}
                                        >
                                            <label className="bg_master2 px-4 br_5  py-2">
                                                <div class="acro_custom_icon d-flex align-items-center justify-content-center">
                                                    <svg fill="none" stroke="currentColor" stroke-width="4" viewBox="0 0 48 48" aria-hidden="true" focusable="false" class="arco-icon arco-icon-plus"><path d="M5 24h38M24 5v38"></path></svg>
                                                    {"secondryFile" == "primaryFile" ? "Capture" : "Upload"}
                                                    {"secondryFile" !== "primaryFile" && (
                                                        <input
                                                            accept={".jpeg,.jpg,.png"}
                                                            type="file"
                                                            className="d-none"
                                                            onChange={(e) => handleFileUpload(e, "secondryFile")}
                                                        />
                                                    )}
                                                </div>
                                            </label>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className={` ${uploadFileData["secondryFile"] ? "" : "d-none"}  `}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h2 className="py-2 py-sm-3 mb-0  font_13 fw-bold ws_nowrp  text-center">
                                            Uploaded data
                                        </h2>
                                        <div className=" rounded p-2">
                                            <img
                                                src={uploadFileData["secondryFile"]}
                                                loading="lazy"
                                                className="w-100 rounded object_fit_contain UploadSignExtractImg"
                                            />
                                        </div>
                                    </div>

                                    <h3 className="font_13 mb-0 pt-2 text-center  ">

                                        {"secondryFile" == "primaryFile" ? "Capture Image" : "upload a file?"}
                                        <label
                                            className="text_master2 ms-1"
                                            onClick={() => handleCapture("secondryFile")}
                                        >
                                            Click here
                                            {"secondryFile" !== "primaryFile" && (
                                                <input
                                                    type="file"
                                                    className="d-none"
                                                    accept={"png,jpeg,jpg"}
                                                    onChange={(e) => handleFileUpload(e, "secondryFile")}
                                                />
                                            )}
                                        </label>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className={`col-12 d-none text-center mt-3 ${Object.values(
                    uploadFileData
                ).some((itm) => itm)}`}
            >
                <button
                    className={`btn btn-master2 cursor-pointer ${!Object.values(uploadFileData).every((itm) => itm) ? "disable_div" : ""}`}

                    onClick={handleMatchScore}
                >
                    Match Score

                </button>
            </div>
            <div className={`${Object.keys(responseData).length ? "" : "d-flex mt-5"} `}>
                <div className="bg_light4 m-auto px-3 py-2 br_10">
                    <p className='text-black d-flex mb-0 align-items-center fw_500'>Face match score is <span className='ms-2 font_40 fw_600 text-success'>0.84</span></p>

                    {/* {formateResponse()} */}
                </div>
            </div>

            {
                <div
                    className={`overlay_modal bg_dark75p position-fixed top-0 start-0 w-100 h-100 zi_1  ${!openCam ? "d-none" : " "
                        } `}
                >
                    <div></div>
                    <div className="d-flex justify-content-center align-items-center h-100 px-3 px-md-4 py-2">
                        <div className="container_t2 ">
                            <Capture
                                handleClose={handleCamClose}
                                setCaptureImage={setUploadFileData}
                                CaptureImage={uploadFileData.primaryFile}
                            />
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default FaceMatching;
